import Vue from 'vue';
import Chartkick from 'chartkick';
import VueChartkick from 'vue-chartkick';
import { isNil, isFunction, has } from 'lodash';
import Datepicker from 'vuejs-datepicker';
import store from '../vuex/store';
import { transmitter } from '../vuex/Transmitter';
import { glossaryParser } from '../common/glossary-parser';
import { MONTHS } from '../../constants';

class Questionizer
{
    constructor ()
    {
        this.resolver = null;
        this.rejector = null;
        this.element = null;
    }

    make (elementID)
    {
        const self = this;
        return new Promise((resolve, reject) =>
        {
            self.resolver = resolve;
            self.rejector = reject;

            this.element = document.getElementById(elementID);
            if (isNil(this.element))
            {
                reject(new Error(`Élément HTML ${elementID} introuvable.`));
                return;
            }

            // Survey components:
            Vue.component('store-feeder', require('../vue/store-feeder.vue'))
            Vue.component('question-title', require('../vue/question-title.vue'))
            Vue.component('radio-button-group', require('../vue/radio-button-group.vue'))
            Vue.component('radio-button-choice', require('../vue/radio-button-choice.vue'))
            Vue.component('checkbox-group', require('../vue/checkbox-group.vue'))
            Vue.component('checkbox-group-row', require('../vue/checkbox-group-row.vue'))
            Vue.component('matrix-column-group', require('../vue/matrix-column-group.vue'))
            Vue.component('matrix-2d-exclusive', require('../vue/matrix-2d-exclusive.vue'))
            Vue.component('matrix-2d-exclusive-row', require('../vue/matrix-2d-exclusive-row.vue'))
            Vue.component('matrix-2d-inclusive', require('../vue/matrix-2d-inclusive.vue'))
            Vue.component('matrix-2d-inclusive-row', require('../vue/matrix-2d-inclusive-row.vue'))
            Vue.component('matrix-2d-exclusive-row-sourced', require('../vue/matrix-2d-exclusive-row-sourced.vue'))
            Vue.component('matrix-2d-exclusive-row-sourced-row', require('../vue/matrix-2d-exclusive-row-sourced-row.vue'))
            Vue.component('matrix-checkbox-col-sourced', require('../vue/matrix-checkbox-col-sourced.vue'))
            Vue.component('matrix-checkbox-col-sourced-row', require('../vue/matrix-checkbox-col-sourced-row.vue'))
            Vue.component('matrix-2d-inclusive-dynamic-rows', require('../vue/matrix-2d-inclusive-dynamic-rows.vue'))
            Vue.component('matrix-2d-inclusive-dynamic-rows-row', require('../vue/matrix-2d-inclusive-dynamic-rows-row.vue'))
            Vue.component('matrix-3d-col-sourced', require('../vue/matrix-3d-col-sourced.vue'))
            Vue.component('matrix-3d-col-sourced-row', require('../vue/matrix-3d-col-sourced-row.vue'))
            Vue.component('matrix-3d', require('../vue/matrix-3d.vue'))
            Vue.component('matrix-3d-row', require('../vue/matrix-3d-row.vue'))
            Vue.component('completion-percent', require('../vue/completion-percent.vue'))
            Vue.component('question-tip', require('../vue/question-tip.vue'))
            Vue.component('matrix-other', require('../vue/matrix-other.vue'))
            Vue.component('self-disablable', require('../vue/self-disablable.vue'))
            Vue.component('postfill-section', require('../vue/postfill-section.vue'))
            Vue.component('transfer-group', require('../vue/transfer-group'))
            Vue.component('transfer-inputs', require('../vue/transfer-inputs'))
            Vue.component('transfer-outputs', require('../vue/transfer-outputs'))

            // Analyst Search components:
            Vue.component('multiple-select-column', require('../vue/multiple-select-column.vue'))
            Vue.component('multiple-select-column-no-action', require('../vue/multiple-select-column-no-action.vue'))
            Vue.component('multiple-select-enabler', require('../vue/multiple-select-enabler.vue'))
            Vue.component('bilan-chart', require('../vue/bilan-chart.vue'))
            Vue.component('bilan-chart-mesures', require('../vue/bilan-chart-mesures.vue'))
            Vue.component('municipalities-list', require('../vue/municipalities-list.vue'))
            Vue.component('municipalities-item', require('../vue/municipalities-item.vue'))
            Vue.component('spot', require('../vue/spot.vue'))
            Vue.component('question-completion-witness', require('../vue/question-completion-witness.vue'))
            Vue.component('score-debugger', require('../vue/score-debugger.vue'))
            Vue.component('datepicker', Datepicker)
            Vue.component('max-date', require('../vue/max-date'))
            Vue.component('question-selector', require('../vue/question-selector'))
            Vue.component('question-selector-submitter', require('../vue/question-selector-submitter'))
            Vue.component('question-selector-enabler', require('../vue/question-selector-enabler'))
            Vue.component('question-target-selector', require('../vue/question-target-selector'))
            Vue.use(VueChartkick, { Chartkick })

            const bus = new Vue({
                el: this.element,
                store,
                mounted: self.vueMounted.bind(self),
                data: {
                    selectedMonth: window.__month__ || '2018-01',
                    months: MONTHS,
                },
            });
            transmitter.setBus(bus);
            glossaryParser.setBus(bus);
        });
    }

    vueMounted ()
    {
        const $element = $(this.element);
        $element.show();
        const datas = $element.data();

        // In Survey pages:
        if (has(datas, 'accessState') && has(datas, 'sectionId') && !isNil(datas.sectionId))
        {
            if (datas['accessState'] === 2) // App\Models\AnswerSurvey::SURVEY_ACCESS_WRITE = 2
            {
                transmitter.validateCurrentAnswers(datas);
            }
        }

        console.info('VueJS v2 has mounted.');

        if (isFunction(this.resolver))
        {
            this.resolver($element);
        }
    }
}

const questionizer = new Questionizer();

export { questionizer }



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/questionizer.js